import { Card, CardContent, List, ListItem, ListItemText, Stack, Typography } from '@mui/material'
import ClimateSectionTitle from '../common/ClimateSectionTitle'
import type { Adaptation } from '../../../types/adaptations'

type PropertyAdaptationsCardProps = {
  adaptations: Adaptation[]
}

export default function PropertyAdaptationsCard({ adaptations }: PropertyAdaptationsCardProps) {
  if (adaptations.length === 0) return null

  return (
    <Card sx={{ p: 3 }}>
      <Stack spacing={2}>
        <ClimateSectionTitle title="Installed adaptations" />
        <Typography variant="body2" color="text.secondary">
          Effective results reflect the following adaptations installed at this property.
        </Typography>
        <List dense disablePadding>
          {adaptations.map(adaptation => (
            <ListItem key={adaptation.id} disableGutters alignItems="flex-start">
              <ListItemText
                primary={adaptation.transform.label}
                secondary={adaptation.transform.description ?? undefined}
              />
            </ListItem>
          ))}
        </List>
      </Stack>
    </Card>
  )
}
